import LBox from "@components/LBox";
import { Slot } from "expo-router";
import LScreen from "@components/LScreen";
import Header from "@components/Account/Layout/Header/Header";
import { PROFILE_ROUTES } from "@components/Account/Layout/utils";
import { useAuth } from "@utils/firebaseAuth/auth";
import NotLoggedIn from "@components/Account/NotLoggedIn";

export const Layout = () => {
  const { status: authStatus } = useAuth();
  const isLoggedIn = authStatus === "logged-in";

  return (
    <LScreen
      enableAutomaticTopPadding
      enableAutomaticBottomPadding={!isLoggedIn}
    >
      <LBox gap="s4" flex={1}>
        <Header routes={PROFILE_ROUTES} />
        {isLoggedIn ? (
          <Slot />
        ) : (
          <LBox flex={1} alignItems="center" justifyContent="center">
            <NotLoggedIn
              flex={1}
              alignItems="center"
              justifyContent="center"
              width="70%"
              header="Access your Library"
              text="Log in to see your saved playlists, favourites, and listening history."
            />
          </LBox>
        )}
      </LBox>
    </LScreen>
  );
};
